import React from "react"

import GameTitle from "./GameInfo/GameTitle"
import InfoColumn from "./GameInfo/InfoColumn"
import ReviewColumn from "./GameInfo/ReviewColumn"

import { User } from "./../../../CheckLogin"

class GameInfo extends React.Component{
    constructor(){
        super()
        this.state = {
            rating: null
        }
    }
    toggleView = () =>{
        this.setState(prevState =>{
            return {
                isPublicView: !prevState.isPublicView
            }
        }) 
    }
    render(){
        const {data} = this.props
        return(
            <div className="gameInfo" role="main">
                <User.Consumer>
                    {(user)=>(
                        <GameTitle data={data} toggleModal={this.props.toggleModal} isAdmin={user.permissions.includes("ARCADE/SUPER_PERMISSION[DEPRECATED]")} user={user}/>
                    )}
                </User.Consumer>
                <hr />
                <InfoColumn data={data}/>
                <ReviewColumn data={data}/>
            </div>
        )
    }
}

export default GameInfo